import ActionTypes from "../../enums/ActionTypes"
import { createAPIRequestReducer } from "../api"

const revokeReducer = createAPIRequestReducer(ActionTypes.PLANNING_OBJECTS_PROJECT_DETAILS_REVOKE)

export default revokeReducer
